import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { Seo } from "../components/Seo";
import { ArrowLeft, Home } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <Seo title="Page Not Found" description="The page you're looking for doesn't exist. Explore Neuravolt's AI-first software engineering services." path="/404" />
      <section className="min-h-[70vh] flex items-center justify-center px-5 sm:px-8">
        <div className="text-center max-w-lg">
          <h1 className="font-display text-8xl font-bold text-[#FF5A1F] mb-4">404</h1>
          <h2 className="font-display text-3xl font-bold text-[#0B0B0B] mb-4">Page not found</h2>
          <p className="text-neutral-500 text-lg mb-10">The page you're looking for doesn't exist or has been moved.</p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/" className="inline-flex items-center gap-2 bg-[#FF5A1F] text-white font-semibold px-6 py-3 rounded-full hover:bg-[#e04f1a] transition-colors">
              <Home className="w-4 h-4" /> Go Home
            </Link>
            <Link to="/contact" className="inline-flex items-center gap-2 border border-neutral-200 text-[#0B0B0B] font-semibold px-6 py-3 rounded-full hover:border-[#FF5A1F] hover:text-[#FF5A1F] transition-colors">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
